import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/sign/:mstid/:systemuserid/:lan',
      name: 'AccountSign',
      meta: {
        title: '签到'
      },
      component: (resolve) => require(['../components/AccountSign.vue'], resolve)
    },
    {
      path: '/invite/:mstid/:systemuserid/:lan',
      name: 'AccountInvite',
      meta: {
        title: '客户邀约'
      },
      component: (resolve) => require(['../components/AccountInvite.vue'], resolve)
    },
    {
      path: '/success',
      name: 'success',
      meta: {
        title: '楚天科技'
      },
      component: (resolve) => require(['../components/success.vue'], resolve)
    },
    {
      path: '/ad',
      name: 'ad',
      meta: {
        title: 'CRM密码修改'
      },
      component: (resolve) => require(['../components/ad.vue'], resolve)
    },
    {
      path: '/svp/:id',
      name: 'svp',
      meta: {
        title: '楚天科技股份有限公司技术服务报告'
      },
      component: (resolve) => require(['../views/svp.vue'], resolve)
    },
    {
      path: '/resetPwd',
      name: 'resetPwd',
      meta: {
        title: 'CRM重置密码'
      },
      component: (resolve) => require(['../components/resetPwd.vue'], resolve)
    },
    {
      path: '/filetemplate/:entityName',
      name: 'filetemplate',
      meta: {
        title: '模板文件'
      },
      component: (resolve) => require(['../components/filetemplate.vue'], resolve)
    },
    {
      path: '/crmUpload/:entityName/:entityId',
      name: 'crmUpload',
      meta: {
        title: '文件上传'
      },
      component: (resolve) => require(['../views/crmUpload.vue'], resolve)
    },
    {
      path: '/packlist/:id',
      name: 'packlist',
      meta: {
        title: '楚天科技股份有限公司发货清单'
      },
      component: (resolve) => require(['../views/packlist.vue'], resolve)
    },
    {
      path: '/campaigndocumentview/',
      name: 'CampaignDocumentView',
      meta: {
        title: '产品手册下载'
      },
      component: (resolve) => require(['../components/CampaignDocumentView.vue'], resolve)
    },
    {
      path: '/userprofile/:id',
      name: 'userprofile',
      meta: {
        title: '设备档案'
      },
      component: (resolve) => require(['../components/userprofile.vue'], resolve)
    },
    {
      path: '/d/:id',
      name: 'd',
      meta: {
        title: '设备档案'
      },
      component: (resolve) => require(['../components/userprofile.vue'], resolve)
    },
    {
      path: '/customerLogin/:id',
      name: 'customerLogin',
      meta: {
        title: '登录'
      },
      component: (resolve) => require(['../components/customer/customerLogin.vue'], resolve)
    },
    {
      path: '/customerRegister/:id',
      name: 'customerRegister',
      meta: {
        title: '注册'
      },
      component: (resolve) => require(['../components/customer/customerRegister.vue'], resolve)
    },
    {
      path: '/equipRepairList/:userprofileid',
      name: 'equipRepairList',
      meta: {
        title: '设备报修'
      },
      component: (resolve) => require(['../components/customer/equipRepairList.vue'], resolve)
    },
    {
      path: '/equipRepairEdit/:userprofileid/:id?',
      name: 'equipRepairEdit',
      meta: {
        keepAlive: false,
        title: '设备报修'
      },
      component: (resolve) => require(['../components/customer/equipRepairEdit.vue'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js